import { haversineMeters } from '../pairing/haversine.js';
export function buildJudgingPostRoute(group, jumps, levels) {
    const jumpById = new Map(jumps.map((jump) => [jump.id, jump]));
    const levelById = new Map(levels.map((level) => [level.id, level]));
    const orderedJumps = group.jumpIds
        .map((jumpId) => jumpById.get(jumpId))
        .filter((jump) => !!jump)
        .sort((a, b) => {
        const aLevel = levelById.get(a.levelId);
        const bLevel = levelById.get(b.levelId);
        const byRunOrder = (aLevel?.runOrder ?? 9999) - (bLevel?.runOrder ?? 9999);
        if (byRunOrder !== 0)
            return byRunOrder;
        const byDisplayOrder = a.displayOrder - b.displayOrder;
        if (byDisplayOrder !== 0)
            return byDisplayOrder;
        return a.number.localeCompare(b.number);
    });
    const missingCoordinateJumpIds = [];
    const stops = [];
    let totalDistanceM = 0;
    for (const jump of orderedJumps) {
        if (jump.latitude == null || jump.longitude == null) {
            missingCoordinateJumpIds.push(jump.id);
            continue;
        }
        const level = levelById.get(jump.levelId);
        const previous = stops.at(-1);
        const distanceFromPreviousM = previous
            ? haversineMeters(previous.latitude, previous.longitude, jump.latitude, jump.longitude)
            : null;
        if (distanceFromPreviousM != null)
            totalDistanceM += distanceFromPreviousM;
        stops.push({
            sequence: stops.length + 1,
            jumpId: jump.id,
            levelId: jump.levelId,
            levelSlug: level?.canonicalSlug ?? null,
            levelDisplayName: level?.displayName ?? 'Unknown level',
            runOrder: level?.runOrder ?? null,
            jumpNumber: jump.number,
            jumpName: jump.name,
            latitude: jump.latitude,
            longitude: jump.longitude,
            distanceFromPreviousM,
        });
    }
    return { stops, missingCoordinateJumpIds, totalDistanceM };
}
//# sourceMappingURL=judgingPostRoute.js.map